// MOCK DATA - all content is mocked on the frontend for now
export const NAV_LINKS = [
  { id: "home", label: "Home" },
  { id: "about", label: "About" },
  { id: "vip", label: "VIP" },
  { id: "gallery", label: "Gallery" },
  { id: "faq", label: "FAQ" },
];

export const PERKS = [
  { icon: "image", text: "Exclusive photos & videos" },
  { icon: "poll", text: "Polls (you decide my next look!)" },
  { icon: "heart", text: "Priority DM replies" },
  { icon: "star", text: "Early access to new content" },
  { icon: "gift", text: "Subscriber-only posts & diary" },
  { icon: "user", text: "VIP-only videos just for you" },
];

export const INTERESTS = [
  { icon: "pin", label: "Bangalore" },
  { icon: "plane", label: "Travel" },
  { icon: "gym", label: "Gym" },
  { icon: "food", label: "Foodie" },
  { icon: "music", label: "Music" },
  { icon: "paw", label: "Dog Lover" },
  { icon: "heart", label: "Good Conversations" },
];

export const SOCIALS = [
  { id: "instagram", name: "Instagram", handle: "@silkymaaya", url: "https://www.instagram.com/silkymaaya" },
];

export const FAQS = [
  { q: "What do I get with Maya VIP?", a: "Exclusive photos & videos, priority DM replies, polls, early access to new content, subscriber-only diary posts and VIP-only videos." },
  { q: "How much does VIP cost?", a: "Maya VIP is ₹499/month. You can cancel anytime from your account." },
  { q: "How do I chat with Maya?", a: "Chatting with Maya is a VIP member perk. Join VIP to start chatting, or sign in if you're already a member." },
  { q: "Can I cancel anytime?", a: "Yes, there are no lock-ins. Cancel whenever you like and keep access until the end of your billing period." },
];

export const LEGAL = {
  privacy: { title: "Privacy Policy", body: "We respect your privacy. We only store the minimum information needed to provide chat and VIP features. We never sell your data to third parties. (Mock content)" },
  terms: { title: "Terms of Service", body: "By using this site you confirm you are 18+ and understand that Maya is a fictional AI-generated character. Subscriptions renew monthly until cancelled. (Mock content)" },
};
